import Icon from 'ol/style/Icon.js';
import { Style } from 'ol/style.js';

const markerSVG = (color) => {
  return btoa(`<svg width="42" height="50" viewBox="-4 0 36 36" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#FFFFFF" stroke="#FFFFFF" stroke-width="1">
    <g transform="translate(-125.000000, -643.000000)">
      <g transform="translate(37.000000, 169.000000)">
        <g transform="translate(78.000000, 468.000000)">
          <g transform="translate(10.000000, 6.000000)">
            <path id="marker-shape" fill="${color}" d="M14,0 C21.732,0 28,5.641 28,12.6 C28,23.963 14,36 14,36 C14,36 0,24.064 0,12.6 C0,5.641 6.268,0 14,0 Z"></path>
            <circle id="marker-center" fill="#FFFFFF" fill-rule="nonzero" cx="14" cy="14" r="6"> </circle>
          </g>
        </g>
      </g>
    </g>
</svg>
`)
}

const markerStyle = ({ color, scale = 0.7 }) => {
  const image = new Icon({
    anchor: [0.5, 1],
    anchorXUnits: "fraction",
    anchorYUnits: "fraction",
    opacity: 1,
    scale,
    src: "data:image/svg+xml;base64," + markerSVG(color),
  })

  const style = new Style({ image, })

  return ([style])
};

export { markerStyle }
